import React, { Component  } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderTitle } from '../../../components/molecues';
import { ScrollView } from '../../../../common/components/atoms';
import { OVERVIEW, VERB_TITLE, NOUM_TITLE } from '../../../common/constants.js';
import meinVisual_verb from '../../../components/atoms/data/meinVisual_verb.svg';
import meinVisual_noum from '../../../components/atoms/data/meinVisual_noum.svg';

class CognitionGrammar extends Component {
    constructor(props) {
        super(props);
        this.refScroll = React.createRef();

        this.state = {
            current: 1,
            verbDisplay: (localStorage.getItem('NoumDisplay') === "true") ? false : true,
            noumDisplay: (localStorage.getItem('NoumDisplay') === "true") ? true : false,

            GrammarScroll: localStorage.getItem('GrammarScroll') ? localStorage.getItem('GrammarScroll') : 0,
        }
    }
    componentDidMount() {
        this.refScroll.current.scrollTo(this.state.GrammarScroll);
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    onClickHome = () => {
        this.props.history.replace('/home');
    }
    onClickVideo(edition,i) {
        let fileName = edition + ("0" + i).slice(-2);
        this.props.dispatch({
            type: "LoadVideo",
            ctgFileName: fileName,
        });
        localStorage.setItem('GrammarScroll', this.refScroll.current.getScrollPos());
        this.props.history.push('/VideoCognitionGrammar');
    }
    createTopInfo(id) {
        let topInfo = [];
        if(id === 1){
            topInfo.push(
                <TopInfoIcon key={id + "topInfoIcon"}>
                    <img alt="mein_visual" src={meinVisual_verb} width="100%" />
                </TopInfoIcon>
            );
        } else {
            topInfo.push(
                <TopInfoIcon key={id + "topInfoIcon"}>
                    <img alt="mein_visual" src={meinVisual_noum} width="100%" />
                </TopInfoIcon>
            );            
        }
        topInfo.push(
            <TopInfoText key={id + "topInfoTest"}>
                {OVERVIEW[id]}
            </TopInfoText>
        );        
        return topInfo;
    }
    createVerbCourse(start,end) {
        let verCourse = [];
        for(let i=start; i <= end; i++){
            verCourse.push(
                <CourseSelectionA key={i + "verCourse"} onClick={e => this.onClickVideo("d",i)}>
                    <CourseIcon>
                        <i className="fas fa-play" />
                    </CourseIcon>
                    <CourseText>
                        {i + "．"}
                    </CourseText>
                    <CourseText>
                        {VERB_TITLE[i]}
                    </CourseText>
                </CourseSelectionA>
            );
        }
        return verCourse;
    }
    createNoumCourse(start,end) {
        let noumCourse = [];
        for(let i=start; i <= end; i++){
            noumCourse.push(
                <CourseSelectionB key={i + "noumCourse"} onClick={e => this.onClickVideo("m", i)}>
                    <CourseIcon>
                        <i className="fas fa-play" />
                    </CourseIcon>
                    <CourseText>
                        {i + "．"}
                    </CourseText>
                    <CourseText>
                        {NOUM_TITLE[i]}
                    </CourseText>
                </CourseSelectionB>
            );
        }
        return noumCourse;
    }

    onClickVerb = () => {
        this.setState({ verbDisplay: true });
        this.setState({ noumDisplay: false });
        localStorage.setItem('NoumDisplay', false);
    }
    onClickNoum = () => {
        this.setState({ verbDisplay: false });
        this.setState({ noumDisplay: true });
        localStorage.setItem('NoumDisplay', true);
    }
    createContents = () => {
        return(
            <React.Fragment>
            <EditionSelect>
                <VerbEdition Display={this.state.verbDisplay} onClick={this.onClickVerb}>
                    動詞・助動詞編
                </VerbEdition>
                <NoumEdition Display={this.state.noumDisplay} onClick={this.onClickNoum}>
                    名詞編
                </NoumEdition>
            </EditionSelect>
            <VerbGroup Display={this.state.verbDisplay}>
                <TopInfoA>{this.createTopInfo(1)}</TopInfoA> 
                <ChapterBar>第1章：英語話者が見ている世界</ChapterBar>
                    {this.createVerbCourse(0,1)}
                <ChapterBar>第2章：文型は意味のユニット</ChapterBar>
                    {this.createVerbCourse(2,5)}
                <ChapterBar>第3章：時制とは何なのか</ChapterBar>
                    {this.createVerbCourse(6,12)}
                <ChapterBar>第4章：助動詞とは何なのか</ChapterBar>
                    {this.createVerbCourse(13,18)}
                <ChapterBar>第5章：仮定法のポイントは動詞にあり</ChapterBar>
                    {this.createVerbCourse(19,21)}
            </VerbGroup>
            <NoumGroup Display={this.state.noumDisplay}>
                <TopInfoB>{this.createTopInfo(2)}</TopInfoB> 
                <ChapterBar>第1章：可算名詞と不可算名詞が見ている世界</ChapterBar>
                    {this.createNoumCourse(0,5)}
                <ChapterBar>第2章：話し手の見方で決まる可算・不可算</ChapterBar>
                    {this.createNoumCourse(6,8)}
                <ChapterBar>第3章：「概念の名詞」と「存在の名詞」</ChapterBar>
                    {this.createNoumCourse(9,13)}
                <ChapterBar>第4章：名詞をとりまく様々な表現</ChapterBar>
                    {this.createNoumCourse(14,17)}
            </NoumGroup>
            </React.Fragment>
        );
    }    
    render() {
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
        };
        const propsScroll = {
            width: '100%',
            height: (window.innerHeight - 64 ) + "px",
            contents: this.createContents()
        };
        return (
            <Body>
                <HeaderTitle {...propsHeader}></HeaderTitle>
                <ScrollView ref={this.refScroll} {...propsScroll} />
            </Body>
        );
    }
}
const mapStateToProps = store => {
    return {
        user: store.login.user,
    }
};
const connectedCognitionGrammar = connect(mapStateToProps)(CognitionGrammar);
export { connectedCognitionGrammar as CognitionGrammar };

const Body = styled.div`
`;
const EditionSelect  = styled.div`
    width: 95%;
    display:flex;
    border: solid;
    border-color:#595959;
    margin:5px;
    font-size:18px;
    justify-content: center;
`;
const VerbEdition = styled.div`
    width: 50%;
    height: 28px;
    background-color: ${props => (props.Display ? '#595959' : '#ffffff')};
    color: ${props => (props.Display ? '#ffffff' : '#595959')};
    border-color:#595959;
    text-align:center;
`;
const NoumEdition = styled.div`
    width: 50%;
    background-color: ${props => (props.Display ? '#595959' : '#ffffff')};
    color: ${props => (props.Display ? '#ffffff' : '#595959')};
    border-color:#595959;
    text-align:center;
`;
const VerbGroup = styled.div`
    width: 100%;
    display: ${props => (props.Display ? '' : 'none')};
`;
const NoumGroup = styled.div`
    width: 100%;
    display: ${props => (props.Display ? '' : 'none')};
`;
const TopInfoA = styled.div`
    width: 95%;
    padding:5px;
    justify-content: center;
`;
const TopInfoB = styled.div`
    width: 95%;
    padding:5px;
    justify-content: center;
`;
const TopInfoIcon = styled.div`
    margin: auto 5px;
`;
const TopInfoText = styled.div`
    font-size:14px;
    margin:10px;
    line-height:17px;
`;
const CourseSelectionA  = styled.div`
    width:92%;
    display:flex;
    padding: 7px 10px 7px 20px;
    border-top-style: none
    border-right-style: none
    border-bottom-style: solid
    border-left-style: none
    border-color: #f2f2f2;
`;
const CourseSelectionB  = styled.div`
    width:92%;
    display:flex;
    padding:7px 10px 7px 20px;
    border-top-style: none
    border-right-style: none
    border-bottom-style: solid
    border-left-style: none
    border-color: #f2f2f2;
`;
const CourseIcon = styled.div`
    margin: auto 10px auto 0;
    font-size:18px;
    color: #00b050;
`;
const CourseText = styled.div`
    font-size:16px;
    font-weight: bold;
    margin:auto 0;
`;
const ChapterBar = styled.div`
    width:92%;
    padding:10px 10px 10px 20px;
    background-color:#e2f0d9;
    font-weight: bold; 
    font-size:15px;
`;